export const localeApiHandler = {
  "https://cms.himam.com/api/localizations/1": {
    method: "GET",
    path: () => `localizations/student-en`
  }
};